function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.25 8.75H15V10h1.25a1.877 1.877 0 011.875 1.875v2.5h1.25v-2.5A3.129 3.129 0 0016.25 8.75zM15 2.5a1.875 1.875 0 110 3.75 1.875 1.875 0 010-3.75zm0-1.25a3.125 3.125 0 100 6.25 3.125 3.125 0 000-6.25zM14.375 18.75h-1.25V17.5a1.877 1.877 0 00-1.875-1.875h-2.5A1.877 1.877 0 006.875 17.5v1.25h-1.25V17.5a3.129 3.129 0 013.125-3.125h2.5a3.128 3.128 0 013.125 3.125v1.25zM10 8.125a1.875 1.875 0 110 3.75 1.875 1.875 0 010-3.75zm0-1.25a3.125 3.125 0 100 6.25 3.125 3.125 0 000-6.25zM5 8.75H3.75a3.129 3.129 0 00-3.125 3.125v2.5h1.25v-2.5A1.877 1.877 0 013.75 10H5V8.75zM5 2.5a1.875 1.875 0 110 3.75A1.875 1.875 0 015 2.5zm0-1.25A3.125 3.125 0 105 7.5a3.125 3.125 0 000-6.25z"
});

var SvgMyCases = function SvgMyCases(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    title: "Cases icon",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMyCases, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/my-cases.796a565d.svg";
export { ForwardRef as ReactComponent };